import React, { SVGProps } from "react";

const FontSizeLargeIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#66696D" {...props}>
    <path d="M35.364 35L25.68 10.988h-3.708L12.324 35h3.42l2.124-5.328H29.82L31.944 35h3.42zm-6.444-7.992H18.732l5.112-12.924 5.076 12.924z" />
  </svg>
);

export default FontSizeLargeIcon;
